import NextLink from 'next/link';

const Link = (props) => {
  const { type, children, label, newTab, reference, url } = props;

  const href =
    type === 'reference' && typeof reference?.value === 'object' && reference.value.slug
      ? `${reference?.relationTo !== 'pages' ? `/${reference?.relationTo}` : ''}/${
          reference.value.slug
        }`
      : url;

  if (!href) return null;

  const newTabProps = newTab ? { rel: 'noopener noreferrer', target: '_blank' } : {};

  return (
    <NextLink href={href || url || ''} {...newTabProps}>
      {label && label}
      {children && children}
    </NextLink>
  );
};

export { Link };
